// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".drop-zone{background-color:#fff}.drop-zone__hover{background-color:#d7d7d7}.drop-zone,.drop-zone__hover{display:flex;border-radius:.3125rem;transition:background-color .2s}.drop-zone--file-upload,.drop-zone__hover--file-upload{border:.125rem dashed #d7d7d7;padding:2rem}.drop-zone--image-upload,.drop-zone__hover--image-upload{position:relative}", ""]);
// Exports
module.exports = exports;
